import React, { createContext, useContext } from 'react';

export const ProductContext = createContext({
    product: null,
    products: [],
    currentVariant: null,
    variants: [],
    isProductEditMode: false,
    fetchProducts: () => {},
    setCurrentProduct: () => {},
    setCurrentVariant: () => {},
    updateProduct: () => {},
    deleteProduct: () => {},
    updateVariant: () => {},
    removeVariant: () => {},
    setProducts: () => {},
    setVariants: () => {},
    isEditing: false,
    setIsEditing: () => {},
    isGeneratingImages: false,
    setIsGeneratingImages: () => {},
    imageGenerationProgress: {},
    setImageGenerationProgress: () => {},
});

export function useProduct() {
    return useContext(ProductContext);
}
